/**
 * Global Timer Manager
 * Collection section timers override the theme settings global countdown timer.
 */

class GlobalTimerManager {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('timer-expired', this.handleTimerExpiry.bind(this));

    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        this.evaluateTimerDisplay();
        this.setupMutationObserver();
      }, 100);
    });

    setTimeout(() => {
      this.evaluateTimerDisplay();
    }, 1000);

    this.setupThemeEditorListeners();

    window.refreshTimers = this.evaluateTimerDisplay.bind(this);
  }

  setupThemeEditorListeners() {
    const reevaluate = () => {
      clearTimeout(this.evaluateTimeout);
      this.evaluateTimeout = setTimeout(() => {
        this.evaluateTimerDisplay();
      }, 100);
    };

    document.addEventListener('shopify:section:load', reevaluate);
    document.addEventListener('shopify:section:unload', reevaluate);
    document.addEventListener('shopify:section:reorder', reevaluate);
  }

  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldReevaluate = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
          if (
            nodes.some(
              (node) =>
                node.nodeType === Node.ELEMENT_NODE &&
                (node.matches?.('[data-section-type="countdown-timer"]') ||
                  node.querySelector?.('[data-section-type="countdown-timer"]'))
            )
          ) {
            shouldReevaluate = true;
          }
          return;
        }

        if (
          mutation.type === 'attributes' &&
          (mutation.attributeName === 'style' ||
            mutation.attributeName === 'class' ||
            mutation.attributeName === 'hidden' ||
            mutation.attributeName === 'data-should-show-timer')
        ) {
          const target = mutation.target;
          if (
            target.matches('[data-section-type="countdown-timer"]') ||
            target.closest('[data-section-type="countdown-timer"]')
          ) {
            shouldReevaluate = true;
          }
        }
      });

      if (shouldReevaluate) {
        clearTimeout(this.evaluateTimeout);
        this.evaluateTimeout = setTimeout(() => {
          this.evaluateTimerDisplay();
        }, 100);
      }
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['style', 'class', 'hidden', 'data-should-show-timer'],
    });
  }

  handleTimerExpiry(event) {
    const { isGlobalTimer } = event.detail;

    if (!isGlobalTimer) {
      setTimeout(() => {
        this.evaluateTimerDisplay();
      }, 500);
    }
  }

  hideSettingsGlobalTimer() {
    const globalTimerFromSettings = document.querySelector('#global-timer-from-settings');
    if (globalTimerFromSettings) {
      globalTimerFromSettings.style.display = 'none';
    }
  }

  hideAllSectionTimers() {
    document
      .querySelectorAll('[data-section-type="countdown-timer"][data-should-show-timer="true"]')
      .forEach((section) => {
        section.style.display = 'none';
      });
  }

  showSettingsGlobalTimer() {
    if (this.isHomepage()) return;

    const globalTimerFromSettings = document.querySelector('#global-timer-from-settings');
    if (globalTimerFromSettings) {
      globalTimerFromSettings.style.removeProperty('display');
    }
  }

  showSectionTimers() {
    document
      .querySelectorAll('[data-section-type="countdown-timer"][data-should-show-timer="true"]')
      .forEach((section) => {
        section.style.display = 'block';
      });
  }

  evaluateTimerDisplay() {
    const settingsGlobalTimer = document.querySelector('#global-timer-from-settings');
    const sectionTimers = document.querySelectorAll('[data-section-type="countdown-timer"]');
    let hasActiveSectionTimer = false;

    sectionTimers.forEach((section) => {
      const timerElement = section.querySelector('countdown-timer');
      // A section with no countdown element is a banner whose end time was left
      // empty on purpose — still valid content, so only an expired countdown
      // disqualifies the section.
      const isExpired = timerElement !== null && timerElement.getAttribute('data-expired') !== null;
      const shouldShowTimer = section.dataset.shouldShowTimer === 'true';
      const isVisible = section.offsetParent !== null;

      if (shouldShowTimer && isVisible && !isExpired) {
        hasActiveSectionTimer = true;
      }
    });

    if (hasActiveSectionTimer) {
      this.showSectionTimers();
      this.hideSettingsGlobalTimer();
      return;
    }

    if (settingsGlobalTimer && !this.isHomepage()) {
      this.hideAllSectionTimers();
      this.showSettingsGlobalTimer();
      return;
    }

    this.hideSettingsGlobalTimer();
    this.hideAllSectionTimers();
  }

  isHomepage() {
    return (
      window.location.pathname === '/' ||
      document.body.classList.contains('template-index') ||
      document.querySelector('body[data-template="index"]')
    );
  }
}

if (!window.globalTimerManager) {
  window.globalTimerManager = new GlobalTimerManager();
}
